import React, { useState, useEffect } from "react";
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Typography,
  Box,
  Button,
  Container,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "styled-components";
import { fetchAvailableEvents } from "../../../services/eventService";
import CustomButton from "./atoms/CustomButton";

const EventListPage = () => {
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();
  const theme = useTheme();

  useEffect(() => {
    const loadEvents = async () => {
      try {
        const data = await fetchAvailableEvents(); // Use the service function
        setEvents(data);

        console.log("events: ", data);
      } catch (error) {
        console.error("Failed to load events", error);
      }
    };
    loadEvents();
  }, []);

  return (
    <Container maxWidth="xl" sx={{ mt: 4, fontFamily: "basic-sans" }}>
      <Typography variant="h4" gutterBottom sx={{ fontFamily: "basic-sans" }}>
        Available Events
      </Typography>
      <Box
        sx={{
          mb: 8,
          borderBottom: `1px solid ${theme.colors.darkGray}`,
        }}
      ></Box>
      <Grid container spacing={4}>
        {events.map((event) => {
          const thumbnailUrl = event.randomSaleId
            ? `https://swayer.blob.core.windows.net/${event.randomSaleId}-pub/_thumb_large.jpg`
            : null;

          return (
            <Grid item xs={12} sm={6} md={4} lg={3} key={event.id}>
              <Card
                sx={{
                  borderRadius: "20px",
                  backgroundColor: theme.colors.mediumPurple,
                  color: "white",
                }}
              >
                {thumbnailUrl && (
                  <CardMedia
                    component="div"
                    sx={{
                      paddingTop: "56.25%", // 16:9 aspect ratio
                      backgroundImage: `url(${thumbnailUrl})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                    alt={event.title || "Content Thumbnail"}
                  />
                )}
                <CardContent>
                  <Typography
                    variant="h6"
                    sx={{ fontFamily: "basic-sans", fontWeight: 700 }}
                  >
                    {event.title}
                  </Typography>
                  <Typography variant="body2" sx={{ fontFamily: "basic-sans" }}>
                    {event.description}
                  </Typography>
                </CardContent>
                <CardActions>
                  <CustomButton
                    onClick={() =>
                        navigate("/challenge/event", { state: { event } })
                      }                    theme={theme}
                    sx={{
                      backgroundColor: theme.colors.darkBlue,
                      "&:hover": {
                        backgroundColor: theme.colors.blue,
                      },
                    }}
                  >
                    Event Preview
                  </CustomButton>
                </CardActions>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

export default EventListPage;
